import { store } from './store.js';
export function Cart(props){
	return{
		...props,
		store,
		data: {
			quantity: 1,
			_nonce: wpData.nonce,
		},
		AddProduct(cartIndex){
			let data = {
				...this.data,
				action: 'add_to_cart',
				product_id: store.cart.items[cartIndex].product_id,
				variation_id: store.cart.items[cartIndex].variation_id || 0,
			}
			store.showRotateLogo = true;
			store.SendAjaxRequest(data)
				.then(response => {
					if (response.success) {
						store.cart = response.data.cart;
					} else {
						console.error(response.data.message);
					}
				})
				.catch(console.error)
				.finally(() => store.showRotateLogo = false);
		},
		DecreaseProduct(cartIndex){
			let data = {
				...this.data,
				action: 'decrease_cart_quantity',
				product_id: store.cart.items[cartIndex].product_id,
				variation_id: store.cart.items[cartIndex].variation_id || 0,
			}
			store.showRotateLogo = true;
			store.SendAjaxRequest(data)
				.then(response => {
					if (response.success) {
						store.cart = response.data.cart;
					} else {
						console.error(response.data.message);
					}
				})
				.catch(console.error)
				.finally(() => store.showRotateLogo = false);
		},
		RemoveProduct(cartIndex){
			let data = {
				...this.data,
				action: 'remove_from_cart',
				product_id: store.cart.items[cartIndex].product_id,
				variation_id: store.cart.items[cartIndex].variation_id || 0,
			}
			store.showRotateLogo = true;
			store.SendAjaxRequest(data)
				.then(response => {
					if (response.success) {
						store.cart = response.data.cart;
					} else {
						console.error(response.data.message);
					}
				})
				.catch(console.error)
				.finally(() => store.showRotateLogo = false);
		},
	}
}